import { createSelector } from '@reduxjs/toolkit';

import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectAttributesByIriSelector } from 'src/selectors/projectAttributesByIri';
import { getProjectAttributesByDomain } from 'src/utils/getProjectAttributesByDomain';

export const projectAttributesByDomainSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      projectAttributesByIriSelector(projectId),
      getProjectAttributesByDomain
    )
);
